import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  APPLICANT_INFO_FORM,
  applicantInfoFormFail,
  applicantInfoFormSuccess
} from "../actions/applicantInfoForm";
import {
  updateProspectId,
  updateProspect,
  updateValidRoCode,
  updateRoEmail
} from "../actions/appConfig";
import { resetInputsErrors, setInputsErrors } from "../actions/serverValidation";
import { generateCodeSuccess } from "../actions/otp";
import { otp, prospect as prospectApi } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import {
  getAccountType,
  getApplicationInfo,
  getAuthorizationHeader,
  getIsIslamicBanking,
  getIsIslamicBankingFromApplicantInfo,
  getIsRecaptchaEnable
} from "../selectors/appConfig";
import { FieldsValidationError } from "../../api/serverErrors";
import { APP_STOP_SCREEN_RESULT, NEXT, SAVE, UAE_CODE } from "../../constants";
import { getProspect } from "../selectors/appConfig";
import { getReCaptchaToken } from "../selectors/reCaptcha";
import { getLeadSource } from "../selectors/appConfig";
// import { setScreeningError } from "../actions/sendProspectToAPI";
import { setScreeningResults } from "./sendProspectToAPI";

export function* applicantInfoFormSaga({ payload }) {
  try {
    const isRecaptchaEnable = yield select(getIsRecaptchaEnable);
    const prospect = yield select(getProspect);
    const applicationInfo = yield select(getApplicationInfo);
    const headers = yield select(getAuthorizationHeader);
    const leadSource = yield select(getLeadSource);
    let isIslamicBanking = yield select(getIsIslamicBanking);
    const accountType = yield select(getAccountType);

    if (isIslamicBanking === null || isIslamicBanking === undefined) {
      isIslamicBanking = yield select(getIsIslamicBankingFromApplicantInfo);
    }

    payload.LeadSource = leadSource?.productName;
    payload.utmSource = leadSource?.utm_source;
    payload.utmMedium = leadSource?.utm_medium;
    payload.utmCampaign = leadSource?.utm_campaign;
    payload.utmContent = leadSource?.utm_content;

    const prospectUpdated = {
      ...prospect,
      applicantInfo: { ...payload, isIslamic: isIslamicBanking, productType: accountType },
      applicationInfo: {
        ...applicationInfo,
        saveType: NEXT,
        actionType: SAVE
      }
    };

    yield put(updateProspect({ prospect: prospectUpdated }));

    const sendingData = { ...prospectUpdated };
    /* istanbul ignore next */
    if (isRecaptchaEnable) {
      sendingData.recaptchaToken = yield select(getReCaptchaToken);
    }

    const createProspectResponse = yield call(prospectApi.create, sendingData, headers);
    const {
      data: { preScreening }
    } = createProspectResponse;
    const isScreeningError = preScreening && preScreening.statusOverAll === APP_STOP_SCREEN_RESULT;
    /* istanbul ignore next */
    if (isScreeningError) {
      yield call(setScreeningResults, createProspectResponse.data);
    } else if (createProspectResponse) {
      const {
        data: { prospectId, validRoCode, roEmail }
      } = createProspectResponse;
      /* istanbul ignore next */
      if (prospectId) {
        const otpGenerationPayload = {
          email: payload.email,
          countryCode: payload.countryCode,
          mobileNo: payload.mobileNo,
          action: "generate",
          /* istanbul ignore next */
          mode: payload.countryCode === UAE_CODE ? "sms" : "email",
          prospectId
        };
        yield call(otp.generate, { ...otpGenerationPayload }, headers);
        yield put(generateCodeSuccess());
        yield put(updateRoEmail(roEmail));
      }

      yield put(updateProspectId(prospectId));
      yield put(
        updateValidRoCode(
          /* istanbul ignore next */
          typeof validRoCode !== "undefined" && validRoCode !== null ? validRoCode : "N"
        )
      );
      yield put(resetInputsErrors());
      yield put(applicantInfoFormSuccess());
    }
  } catch (error) {
    /* istanbul ignore next */
    if (error instanceof FieldsValidationError) {
      yield put(setInputsErrors(error.getInputsErrors()));
    } else {
      log(error);
    }
    yield put(applicantInfoFormFail(error));
  }
}

export default function* applicantInfoSaga() {
  yield all([takeLatest(APPLICANT_INFO_FORM, applicantInfoFormSaga)]);
}
